<button app-button buttonType="outline" type="button" (click)="exit()">
  Exit
</button>